import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Divider, List, ListItem, ListItemText, useTheme} from "@mui/material";
import {drawerRoutes, HOME_ROUTE, Route, routeVisibleForUser} from "../router/routes";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router";
import {useDrawer} from "./DrawerProvider";
import {palette} from "../../technical/style/theme";
import {useAccount} from "../../../administration/users/AccountProvider";
import {useUserManager} from "../../technical/auth/UserManagerContext";

export function DrawerContent() {
  const {t} = useTranslation();
  const theme = useTheme();
  const account = useAccount();
  const navigate = useNavigate();
  const location = useLocation();
  const userManager = useUserManager();
  const {toggleDrawer} = useDrawer();
  const [activeRoute, setActiveRoute] = useState<Route>(HOME_ROUTE);
  const visibleRoutes = useMemo(() => drawerRoutes.filter(routeVisibleForUser(account)), [account]);

  useEffect(() => {
    // We try to find out which entry in the drawer should be highlighted
    const path = location.pathname;
    let matches = visibleRoutes.filter(route => path.startsWith(route.path))
    if (matches.length === 2) {
      // If it contains home route we remove it
      matches = matches.filter((router) => router !== HOME_ROUTE);
    }
    if (matches.length === 1) {
      setActiveRoute(matches[0]);
    }
  }, [location, visibleRoutes])

  const navigateTo = useCallback((route: Route) => {
    // console.log('Navigate to ' + route.path);
    toggleDrawer();
    setActiveRoute(route);
    navigate(route.path);
  }, [navigate, toggleDrawer]);

  let actualDrawerGroup: string | undefined = undefined;

  return (
    <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
      <List style={{height: '100%'}}>
        {visibleRoutes.map((route) => {
            if (route.drawerEntry?.drawerGroup && route.drawerEntry?.drawerGroup !== actualDrawerGroup) {
              actualDrawerGroup = route.drawerEntry?.drawerGroup;
              return (
                <React.Fragment key={route.path}>
                  <ListItem key={route.path + '-area'}>
                    <ListItemText primary={t('routes.' + route.drawerEntry?.drawerGroup + '.title')} sx={{...palette.greyTextOpacity,}}
                                  primaryTypographyProps={{variant: 'overline', align: 'left'}}/>
                  </ListItem>
                  <RouteItem route={route} isActive={activeRoute === route} navigate={navigateTo} key={route.path + '-item'}/>
                </React.Fragment>
              )
            }
            return (
              <RouteItem route={route} isActive={activeRoute === route} navigate={navigateTo} key={route.path + '-item'}/>
            )
          }
        )}
        {/*<ListItem key={'user-area'} style={{marginTop: 'auto'}}>*/}
        {/*  <ListItemText primary={t('routes.user.title')} className={classes.subTitle}*/}
        {/*                primaryTypographyProps={{variant: 'overline', align: 'left'}}/>*/}
        {/*</ListItem>*/}
        <ListItem button={true} key={'logout'} onClick={() => userManager.signoutRedirect({
          post_logout_redirect_uri: `${window.location.href}`
        })} sx={{
          color: palette.normal,
          paddingLeft: theme.spacing(3.5),
          ...palette.greyTextOpacity,
          fontSize: '20px',
        }} style={{bottom: '16px', position: 'fixed', width: 240}}>
          <ListItemText primary={t('routes.logout.title')} style={{textAlign: 'left'}}/>
        </ListItem>
      </List>
    </div>
  );

}

function RouteItem(props: {
  route: Route,
  isActive: boolean,
  navigate: (route: Route) => void
}) {
  const {route, isActive, navigate} = props;
  const {t} = useTranslation();
  const theme = useTheme();
  const sx = isActive ? {
    color: palette.primary,
    paddingLeft: theme.spacing(3),
    borderLeftWidth: 4,
    borderLeftStyle: 'solid',
    borderLeftColor: palette.primary,
    fontSize: '20px',
    backgroundColor: palette.primaryTransparent,
    '&:hover': {
      backgroundColor: palette.primaryTransparent,
    },
  } : {
    color: palette.normal,
    paddingLeft: theme.spacing(3.5),
    ...palette.greyTextOpacity,
    fontSize: '20px',
  };
  return (
    <>
      {route.drawerEntry?.dividerBefore && <Divider sx={{
        backgroundColor: theme.palette.background.light,
        margin: theme.spacing(1),
        marginTop: '20%',
      }} key={route.path + '-dividerBefore'}/>}
      <ListItem button={true} key={route.path} onClick={() => navigate(route)} sx={sx}>
        <ListItemText primary={t('routes.' + route.drawerEntry?.titleKey + '.title')} style={{textAlign: 'left'}}/>
      </ListItem>
      {route.drawerEntry?.dividerAfter && <Divider sx={{
        backgroundColor: theme.palette.background.light,
        margin: theme.spacing(1),
        marginTop: '20%',
      }}/>}
    </>
  );
}
